module.exports = __webpack_public_path__ + "static/footer-logo-8d178ac586f7348503a28a9e7cb3c1f6.svg";